<template>
  <ion-menu content-id="main-content" >
    <ion-header>
      <ion-toolbar>
        <ion-buttons  slot="start">
          <ion-menu-button color="light"></ion-menu-button>
        </ion-buttons>
        <ion-title>
          <img src="@/assets/logo.png" width="200">
        </ion-title>
      </ion-toolbar>
    </ion-header>
  
    

    <ion-content class="ion-padding">
      <ion-list lines="full">
        <ion-menu-toggle :auto-hide="true">
          <ion-item button routerLink="/explotaciones">
            <ion-icon slot="start" :icon="homeOutline" />
            <ion-label>Inicio</ion-label>
          </ion-item>

          <ion-item button routerLink="/tabs/notificaciones" v-if="isMobile">           
              <ion-icon slot="start" :icon="notificationsOutline" />            
              <ion-label>Notificaciones</ion-label>
          </ion-item>

          <ion-item button routerLink="/tabs/usuario">
            <ion-icon slot="start" :icon="personCircleOutline" />
            <ion-label>Datos de Usuario</ion-label>
          </ion-item>

          <ion-item button routerLink="/tabs/explotacion">
            <ion-icon slot="start" :icon="informationCircleOutline" />
            <ion-label>Explotación</ion-label>
          </ion-item>

          <ion-item button routerLink="/tabs/actas">
            <ion-icon slot="start" :icon="readerOutline" />
            <ion-label>Actas</ion-label>
          </ion-item>

          <ion-item button routerLink="/tabs/informes/list">
            <ion-icon slot="start" :icon="eyeOutline" />
            <ion-label>Informes</ion-label>
          </ion-item>

          <ion-item button routerLink="/tabs/lotes">
            <ion-icon slot="start" :icon="informationCircleOutline" />
            <ion-label>Lotes</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <!-- Logout Item -->
        <ion-item button :detail="true" :detailIcon="caretForwardOutline" @click="makeLogout()">
          <ion-icon slot="start" :icon="logOutOutline" />
          <ion-label color="danger">Desconectarse</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>

  </ion-menu>

</template>

<script lang="ts" setup>
import { 
  IonMenuToggle,
  IonList,
  IonItem,
  IonMenu,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonContent, 
  IonLabel, 
  IonIcon, 
  IonButtons,
  IonMenuButton 
} from '@ionic/vue';
import { 
  caretForwardOutline, 
  informationCircleOutline, 
  readerOutline, 
  eyeOutline, 
  logOutOutline, 
  homeOutline, 
  personCircleOutline, 
  notificationsOutline
} from 'ionicons/icons';
import { useUser } from '@/composables/useUser';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { makeLogout, isMobile } = useUser();

</script>

